const timeline = [
  {
    job: "Software Lead Engineer",
    company: "Capgemini",
    role: "Mission for an international energy company",
    location: "Capgemini",
    start: "Sep 2023",
    end: "Present",
    projects: [
      "Led application transition across Digital & ERP scope",
      "Maintained and evolved enterprise PHP/Symfony applications",
      "Handled L2/L3 support, incidents and change requests via ServiceNow",
      "Worked on APIs, SOAP integrations, databases and production releases",
      "Coordinated with business, architecture, operations and client stakeholders",
    ],
  },

  {
    job: "Full-stack Developer",
    company: "KECHWEB",
    role: "Laravel • Vue.js • REST APIs",
    location: "Marrakesh, Morocco (Remote)",
    start: "Mar 2022",
    end: "Nov 2023",
    projects: [
      "Feature development and maintenance for client web apps",
      "API integrations, bug fixing, performance and delivery improvements",
      "Collaboration with product/stakeholders to deliver production-ready releases",
    ],
  },

  {
    job: "Full-stack Developer",
    company: "Filovent",
    role: "Laravel • MySQL • Web revamp",
    location: "Boulogne-Billancourt, France",
    start: "May 2021",
    end: "Jun 2022",
    projects: [
      "Website overhaul: testing, design analysis, and feature implementation",
      "Backend improvements (Laravel + MySQL) and UI integration",
      "Quality checks and iterative delivery with the team",
    ],
  },

  {
    job: "Laravel Developer",
    company: "NJT GROUP",
    role: "PHP • Laravel • Web + API",
    location: "Marrakesh, Morocco",
    start: "Jan 2019",
    end: "Jun 2021",
    projects: [
      "RADEEC online solution: analysis, design, and development",
      "THERMODITY internal platform: web app + API for monitoring & control",
      "Production maintenance, improvements, and feature delivery",
    ],
  },

  {
    job: "Internship Trainee",
    company: "GREEN WATECH",
    role: "PHP • MySQL",
    location: "Marrakesh, Morocco",
    start: "Jan 2019",
    end: "Mar 2019",
    projects: [
      "Company website: design + build to present business activities",
      "Content integration focused on environmental topics and solutions",
    ],
  },
];

export default timeline;
